import * as fs from "../utils/formStateUtils";

/* 섹션 추가 (페이지에) */
export const addSection = (formStructure, pageId) =>
  fs.addSectionToPage(formStructure, pageId);

/* 섹션 삭제 */
export const deleteSection = fs.deleteSection;

/* 섹션 제목 업데이트 */
export const updateSectionTitle = (formStructure, sectionId, newTitle) =>
  fs.updateSectionTitle(formStructure, sectionId, newTitle);

/* 섹션 이동 (다른 페이지로 또는 같은 페이지 reorder) */
export const moveSection = fs.moveSection;

/* 특정 섹션이 속한 페이지 ID 반환 */
export const findPageIdForSection = fs.findPageIdForSection;
